class HHCartBundleVariants extends HTMLElement {
  connectedCallback() {
    const variantsJSON = this.querySelector('[data-bundle-parent-variants]')
    this.parentVariants = variantsJSON ? JSON.parse(variantsJSON.textContent) : []
    this.selections = new Map()
    this.openDropdown = null

    this.dropdownButtons = this.querySelectorAll('.vp__dropdown-button')
    this.dropdownButtons.forEach((button) => {
      const content = this.getDropdownContent(button)
      if (!content) return
      button.addEventListener('click', () => this.toggleDropdown(button, content))
    })

    document.addEventListener('click', (event) => {
      if (!this.openDropdown) return
      const { button, content } = this.openDropdown
      if (content.contains(event.target) || button.contains(event.target)) return
      this.closeAllDropdowns()
    })

    window.addEventListener('scroll', () => this.closeAllDropdowns(), true)

    this.querySelectorAll('.cart-item__bundle-item[data-component-index]').forEach((bundleItem) => {
      const index = Number(bundleItem.dataset.componentIndex)
      const componentVariant = this.getComponentVariant(bundleItem)
      if (componentVariant) {
        this.selections.set(index, componentVariant.title)
      }

      bundleItem.querySelectorAll('.vp__input input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', (event) => this.onVariantChange(event, bundleItem, index))
      })
    })
  }

  getDropdownContent(button) {
    const controlsId = button.getAttribute('aria-controls')
    return controlsId ? document.getElementById(controlsId) : null
  }

  getComponentVariantData(bundleItem) {
    const variantJSON = bundleItem.querySelector('[data-component-variants]')
    return variantJSON ? JSON.parse(variantJSON.textContent) : []
  }

  getComponentVariant(bundleItem) {
    const checkedInputs = Array.from(bundleItem.querySelectorAll('.vp__input input[type="radio"]:checked'))
    if (!checkedInputs.length) return null

    const selectedOptions = checkedInputs.map((radio) => radio.value)
    const variants = this.getComponentVariantData(bundleItem)

    return variants.find((variant) => {
      return variant.options.every((option, optionIndex) => selectedOptions[optionIndex] === option)
    })
  }

  onVariantChange(event, bundleItem, index) {
    if (event.target.disabled) return

    this.updateDropdownSelection(event)

    const selectedVariant = this.getComponentVariant(bundleItem)
    if (!selectedVariant || !selectedVariant.available) return

    this.selections.set(index, selectedVariant.title)

    const selectedTitles = Array.from(this.selections.entries())
      .sort(([a], [b]) => a - b)
      .map(([, title]) => title)

    const matchingVariant = this.parentVariants.find((variant) => {
      return variant.options.every((option) => selectedTitles.includes(option))
    })

    if (!matchingVariant || !matchingVariant.available) return

    this.dispatchEvent(
      new CustomEvent('changeBundleVariant', {
        bubbles: true,
        composed: true,
        detail: {
          key: this.dataset.key,
          variantId: matchingVariant.id,
          quantity: Number(this.dataset.quantity),
        },
      })
    )
  }

  updateDropdownSelection(event) {
    const content = event.target.closest('.vp__dropdown-content')
    if (!content) return

    const button = document.querySelector(`[aria-controls="${content.id}"]`)
    const selectedLabel = content.querySelector('input:checked + label')
    if (!button || !selectedLabel) return

    const selectedSwatch = selectedLabel.querySelector('.vp__dropdown-swatch')
    const buttonSwatch = button.querySelector('.vp__dropdown-swatch')
    if (buttonSwatch && selectedSwatch) {
      buttonSwatch.style.setProperty(
        '--swatch-background',
        getComputedStyle(selectedSwatch).getPropertyValue('--swatch-background')
      )
    }

    button.querySelector('.vp__dropdown-selected').textContent =
      selectedLabel.querySelector('.vp__dropdown-label').textContent

    this.closeAllDropdowns()
  }

  toggleDropdown(button, content) {
    const isExpanded = button.getAttribute('aria-expanded') === 'true'
    this.closeAllDropdowns()

    if (!isExpanded) {
      this.openDropdown = {
        button,
        content,
        parent: content.parentNode,
        nextSibling: content.nextSibling,
      }

      document.body.appendChild(content)
      button.setAttribute('aria-expanded', 'true')
      content.hidden = false
      this.positionDropdown(button, content)
    }
  }

  positionDropdown(button, content) {
    const rect = button.getBoundingClientRect()
    content.classList.add('cart-item__bundle-item-variant-dropdown')
    content.style.position = 'fixed'
    content.style.top = `${rect.bottom}px`
    content.style.left = `${rect.left}px`
    content.style.right = 'auto'
    content.style.width = `${rect.width}px`
    content.style.zIndex = '2147483647'
  }

  closeAllDropdowns() {
    this.dropdownButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'))

    if (!this.openDropdown) return

    const { content, parent, nextSibling } = this.openDropdown

    content.hidden = true
    content.style.position = ''
    content.style.top = ''
    content.style.left = ''
    content.style.right = ''
    content.style.width = ''
    content.style.zIndex = ''

    if (parent) {
      parent.insertBefore(content, nextSibling || null)
    }

    this.openDropdown = null
  }
}

customElements.define('hh-cart-bundle-variants', HHCartBundleVariants)
